// removed by extract-text-webpack-plugin
module.exports = {"timelineSection":"styles-timelineSection--sLu2v","timelineComponentButton":"styles-timelineComponentButton--3mc1I","timelineComponentButtonSelected":"styles-timelineComponentButtonSelected--FppBS","timelineRow":"styles-timelineRow--1yztx","timeline":"styles-timeline--AFItT","timelineHeader":"styles-timelineHeader--36qc1","componentsPanel":"styles-componentsPanel--JEOb8","label":"styles-label--1vXo9","propertiesPanel":"styles-propertiesPanel--Hp_W4","playhead":"styles-playhead--3cp4x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Canvas/styles.scss
// module id = CqjY
// module chunks = 3